import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory<any>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const createUserMfaReducer = createReducer<State, Actions>(initialState, {
  [actions.createUserMfa.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.createUserMfa.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.createUserMfa.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.createUserMfa.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default createUserMfaReducer;
